import { format } from 'date-fns';
import { pluralizeAge } from '@/tools/pluralize';

export const getAge = (birthday: string): number => {
  if (typeof birthday !== 'string' || !birthday.length) return 0;
  const date = birthday;
  const dateArray = date.split('.');
  const newDate = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
  var today = new Date();
  var birthDate = new Date(newDate);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

const getAgeFromBirthday = (birthday: string): string => {
  return pluralizeAge(getAge(birthday));
};

export default getAgeFromBirthday;



// WEBPACK FOOTER //
// ./src/tools/getAgeFromBirthday.ts